export const logRocketApiKey: string = 'xjnijt/letsbetmd';
